import { render, staticRenderFns } from "./Index-Purchase.vue?vue&type=template&id=ea9b8da0&scoped=true"
import script from "./Index-Purchase.vue?vue&type=script&lang=js"
export * from "./Index-Purchase.vue?vue&type=script&lang=js"
import style0 from "./Index-Purchase.vue?vue&type=style&index=0&id=ea9b8da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9b8da0",
  null
  
)

export default component.exports